import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2292c5a6&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=2292c5a6&prod&lang=less&scoped=true&"
import style1 from "./Modal.vue?vue&type=style&index=1&id=2292c5a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292c5a6",
  null
  
)

export default component.exports